module.exports = __webpack_public_path__ + "static/media/lights_icon.5993327e.svg";